import React from 'react';

const months = [
  'January',
  'February',
  'March',
  'April',
  'May',
  'June',
  'July',
  'August',
  'September',
  'October',
  'November',
  'December',
];
const customMonths = [
  'Jan',
  'Feb',
  'Mar',
  'Apr',
  'May',
  'Jun',
  'July',
  'Aug',
  'Sep',
  'Oct',
  'Nov',
  'Dec',
];
const days = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];
const DateFormatter = date => {
  const formattedDate = new Date(date.date);
  const day = formattedDate.getDate(); //23
  const monthName = date.custom
    ? customMonths[formattedDate.getMonth()]
    : months[formattedDate.getMonth()]; //September
  //const dayName = days[formattedDate.getDay()] // Thu
  const year = formattedDate.getFullYear(); // 2019
  const formatted = `${day} ${monthName}, ${year}`;
  return <span>{formatted}</span>;
};

export default DateFormatter;
